import { getFirebaseInstances } from '../../../config/firebase/firebase';

export async function loadAuth() {
  const { auth } = await getFirebaseInstances();
  return auth;
}
